import getFeatures from 'services/growthbook/getFeatures';
import { Context, GrowthBook } from '@growthbook/growthbook-react';
import { getFullErrorObject } from 'utils/getErrorMessage';
import { HttpClientError } from './httpClient';

export type growthBookParams = {
  sessionId: string;
  loggedIn: boolean;
  browser: string;
  url: string;
  eventId: string;
};

let growthbookInstance: GrowthBook<Record<string, unknown>>;

export default function growthBook() {
  async function fetchFeature() {
    try {
      const { features } = await getFeatures();
      growthbookInstance?.setFeatures(features);
      return features;
    } catch (error) {
      const err = getFullErrorObject<HttpClientError>(error) as HttpClientError;
      const { browserLogger } = await import('utils/logger/browserLogger');
      const { error: browserError } = browserLogger();

      browserError(
        {
          message: 'Error when getting remote feature data',
          data: err.message,
        },
        'GrowthBook.fetchFeature',
      );
      return err;
    }
  }

  function setAttributes(params: growthBookParams) {
    growthbookInstance.setAttributes(params);
  }

  function instance(context?: Context) {
    if (growthbookInstance) return growthbookInstance;

    growthbookInstance = new GrowthBook(context);
    return growthbookInstance;
  }

  return {
    fetchFeature,
    setAttributes,
    instance,
  };
}
